import {
  DOCTORS_NAMES_LOADING_ADDRESS,
  DOCTORS_SPECIALITIES_LOADING_ADDRESS,
  panels,
} from "../../variables";
import {
  hideDoctorNamesLoader,
  hideDoctorsLoader,
  showDoctorNamesLoader,
  showDoctorsLoader,
} from "./loaderActions";
import {
  DOCTOR_NAMES_LOADING_FAILED,
  DOCTOR_NAMES_LOADING_SUCCESS,
  DOCTORS_SPECIALITIES_LOADING_FAILED,
  DOCTORS_SPECIALITIES_LOADING_SUCCESS,
  SELECT_DOCTOR_NAME,
  SELECT_DOCTORS_SPECIALITY,
  CLEAN_NAME_SELECTOR,
} from "./types";
import { checkErrorStatusAndExecuteCallback } from "../../utils";
import { setActivePanel } from "./panelsActions";
import { HealthCheckEvents } from "../../api/types";
import Api from "../../api";
import { getErrorMessage, hasResponseErrorCode, removeErrorTitle } from "../../helpers/redux";

export const startDoctorsSpecialitiesLoading =
  (medicalOrganisationId, sessionId, orderId, regionCode) => (dispatch) => {
    const healCheckInstance = Api.healthCheckFor(HealthCheckEvents.getSpecialityList);
    const data = {
      "filter":
        {
          "union": {
            "unionKind": "AND",
            "subs": [
              {
                "simple": {
                  "attributeName": "MO_Id",
                  "condition": "EQUALS",
                  value: medicalOrganisationId,
                }
              },
              {
                "simple": {
                  "attributeName": "Session_Id",
                  "condition": "EQUALS",
                  value: sessionId,
                }
              }
            ]
          }
        },
      "treeFiltering": "ONELEVEL",
      "pageNum": 1,
      "pageSize": "10000",
      "selectAttributes": [
        "Service_Id",
        "Service_Name"
      ],
      "eserviceId": "10000103595",
      "refName": "ServiceOrSpecs"
    }

    const config = {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    };

    dispatch(showDoctorsLoader());
    Api.instance
      .post(DOCTORS_SPECIALITIES_LOADING_ADDRESS, data, config)
      .then((response) => {
        const doctorsSpecialities = response.data.items.map(
          mapLoadedSpecialities
        );

        dispatch(
          doctorsSpecialitiesLoadingSuccess(
            doctorsSpecialities,
            hasResponseErrorCode(response) ? response.data.error : null
          )
        );

        healCheckInstance.sendSuccess();
      })
      .catch((error) => {
        dispatch(doctorsSpecialitiesLoadingFailed(error));
        healCheckInstance.sendFailure({ browserError: error.message });
        checkErrorStatusAndExecuteCallback(error, () =>
          dispatch(setActivePanel(panels.error))
        );
      })
      .finally(() => dispatch(hideDoctorsLoader()));
  };

const mapLoadedSpecialities = (speciality) => {
  return {
    [speciality.attributes[0].name]: speciality.attributes[0].value,
    [speciality.attributes[1].name]: speciality.attributes[1].value,
  };
};

export const doctorsSpecialitiesLoadingSuccess = (
  doctorSpecialities,
  error = null
) => {
  return {
    type: DOCTORS_SPECIALITIES_LOADING_SUCCESS,
    payload: doctorSpecialities,
    error: removeErrorTitle(error?.errorDetail?.errorMessage),
  };
};

export const doctorsSpecialitiesLoadingFailed = (error) => {
  return {
    type: DOCTORS_SPECIALITIES_LOADING_FAILED,
    payload: {
      error,
    },
  };
};

export const selectDoctorSpeciality = (doctorSpeciality) => {
  return {
    type: SELECT_DOCTORS_SPECIALITY,
    payload: doctorSpeciality,
  };
};

export const startDoctorNamesLoading =
  (serviceId, sessionId, orderId, regionCode) => (dispatch) => {
    const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.getSpecialistList);
    const data = {
      filter: {
        union: {
          unionKind: "AND",
          subs: [
            {
              simple: {
                attributeName: "Service_Id",
                condition: "EQUALS",
                value: serviceId,
              },
            },
            {
              simple: {
                attributeName: "Session_Id",
                condition: "EQUALS",
                value: sessionId,
              },
            },
          ],
        },
      },
      treeFiltering: "ONELEVEL",
      pageNum: 0,
      pageSize: 0,
      selectAttributes: ["Resource_Id", "Resource_Name"],
      eserviceId: "10000103595",
      refName: "Resource",
    };

    const config = {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    };
    dispatch(showDoctorNamesLoader());
    Api.instance
      .post(DOCTORS_NAMES_LOADING_ADDRESS, data, config)
      .then((response) => {
        if (hasResponseErrorCode(response)) {
          return dispatch(doctorNamesLoadingFailed(getErrorMessage(response)));
        }
        const doctorNames = response.data.items.map(mapLoadedDoctorName);

        dispatch(doctorNamesLoadingSuccess(doctorNames));

        healthCheckInstance.sendSuccess();
      })
      .catch((error) => {
        dispatch(doctorNamesLoadingFailed(error));
        healthCheckInstance.sendFailure({ browserError: error.message });
        checkErrorStatusAndExecuteCallback(error, () =>
          dispatch(setActivePanel(panels.error))
        );
      })
      .finally(() => dispatch(hideDoctorNamesLoader()));
  };
const mapLoadedDoctorName = (doctorName) => {
  return {
    [doctorName.attributes[0].name]: doctorName.attributes[0].value,
    [doctorName.attributes[1].name]: doctorName.attributes[1].value,
  };
};

export const doctorNamesLoadingSuccess = (doctorNames, error = null) => {
  return {
    type: DOCTOR_NAMES_LOADING_SUCCESS,
    payload: doctorNames,
    error: error?.errorDetail?.errorMessage,
  };
};

export const doctorNamesLoadingFailed = (error) => {
  return {
    type: DOCTOR_NAMES_LOADING_FAILED,
    payload: {
      error,
    },
  };
};
export const cleanNameSelector = () => {
  return {
    type: CLEAN_NAME_SELECTOR,
  };
};

export const selectDoctorName = (doctorName) => {
  return {
    type: SELECT_DOCTOR_NAME,
    payload: doctorName,
  };
};
